import { useAppSelector } from '@perpay-web/fintech/hooks';
import { getJWTData } from '@perpay-web/fintech/selectors/authentication';

const useSpendingLimit = () => {
    const jwtData = useAppSelector(getJWTData);
    return jwtData.spendingLimit;
};

export const useHasSpendingLimit = () => {
    const spendingLimit = useSpendingLimit();
    return spendingLimit > 0;
};
